import { detectedLanguage } from "../utils/getScriptDataAttribute";
import { pluginConfig } from "@/globals/pluginConfig";
import { LANGUAGES } from "./Languages";

const isSupported = (code?: string | null): code is string =>
    !!code && LANGUAGES.some(lang => lang.code === code);

export function getDefaultLanguage() {

    // 1. Prefer the detected page / browser language.
    const detected = detectedLanguage?.split(/[-_]/)?.[0]?.trim();
    if (isSupported(detected)) {
        return detected;
    }

    // 2. Fall back to the language selected on the admin settings page.
    const adminDefault = pluginConfig.language.default;
    if (isSupported(adminDefault)) {
        return adminDefault;
    }

    // 3. Last resort.
    return "en";
}